module.exports = "/images/lifestyle-asia.png?c56ef6592cf3a2ecdee58e6875cd66a3";